// Description: Component that render the steps of the form and shows the current step
// Updated: 01/08/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box } from '@mui/material';
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
import CheckIcon from '@mui/icons-material/Check';

// Components and functions for the project
import themeColors from '../ThemeColors/ThemeColors';

// Render The Component
const StepIndicator = ({ steps, currentStep }) => {
  return (
    <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
      {steps.map((step) => (
        <Box
          key={step.stepNumber}
          sx={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            flexWrap: 'nowrap',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: { xs: '20px', sm: '22px' },
              height: { xs: '20px', sm: '22px' },
              borderRadius: '50%',
              fontSize: { xs: '10px', sm: '14px' },
              fontWeight: 600,
              color: step.stepNumber <= currentStep ? '#FFF' : '#000',
              background: step.stepNumber <= currentStep ? '#8033F4' : '#D9D9DC',
            }}
          >
            {
              step.stepNumber < currentStep ? <CheckIcon sx={{ fontSize: "16px", color: "#fff", width: "16px", height: "16px" }} /> : step.stepNumber
            }
          </Box>

          <NavigateNextOutlinedIcon
            style={{
              fontSize: '25px', // Tamanho menor por padrão
              color: themeColors.purple600,
              display: step.stepNumber === steps.length ? 'none' : 'block',
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default StepIndicator;
